module.exports = __webpack_public_path__ + "img/title.a4cfeac0.png";